import { render, staticRenderFns } from "./NewAwards.vue?vue&type=template&id=9748e1d4&scoped=true&"
import script from "./NewAwards.vue?vue&type=script&lang=js&"
export * from "./NewAwards.vue?vue&type=script&lang=js&"
import style0 from "./NewAwards.vue?vue&type=style&index=0&id=9748e1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9748e1d4",
  null
  
)

export default component.exports